import { useNavigate } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';
import { useTranslation } from 'react-i18next';

interface Props {
  children: React.ReactNode;
}
export const ErrorBoundaryWrapper = ({ children }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <ErrorBoundary navigate={navigate} translate={t}>
      {children}
    </ErrorBoundary>
  );
};
